/***this.$data_null.editor(res.data.data);**/
const data_null = {};
data_null.editor = (res) => {
    if(res){
        for(let i = 0;i<res.length;i++){
            if(res[i] ){
                for(let key in res[i]){
                    if(!res[i][key] && res[i][key] != 0 && key.indexOf("image") == -1){
                        res[i][key] = "N/A";
                        
                    }
                }
            }
            
        }
    }
    return  res;
}
data_null.del = (res) => {
    if(res){
        for(let key in res){
            if( res[key] == "N/A" ){
                res[key] = null;
                
            }
        }
         
        
    }
    return  res;
}

export default data_null;